import type { PricingCampaignModel } from '@/shared/generated'

import { Slot } from '@radix-ui/react-slot'

import { Access } from '@/entities/session'

import { useModals } from '@/shared/lib/modal-manager'

export const EditPricingCampaign = ({
	children,
	pricingCampaign,
}: {
	children: React.ReactNode
	pricingCampaign: PricingCampaignModel
}) => {
	const { showModal } = useModals()

	const handleEditPricingCampaign = () => {
		showModal('PRICING_CAMPAIGN_MODAL', {
			pricingCampaignId: pricingCampaign.id,
			globalPcSetId: pricingCampaign.global_pc_set_id!,
		})
	}

	return (
		<Access permissions={['EDIT_GLOBAL_PRICING_CAMPAIGNS_SETTINGS']}>
			<Slot onClick={handleEditPricingCampaign}>{children}</Slot>
		</Access>
	)
}
